<template>

  <div class="filters">

    <div>
      <product-categories-select v-model="filters.category" :clearable="true"></product-categories-select>
    </div>

  </div>

</template>

<script>
  import ProductCategoriesSelect from './product-categories-select'

  export default {
    name: 'products-filters',

    props: [ 'filters' ],

    watch: {
      filters: {
        deep: true,
        handler () {
          this.$emit('change', this.filters)
        }
      }
    },

    components: {
      ProductCategoriesSelect
    }
  }
</script>

<style scoped lang="scss">

</style>
